import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject, firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ResultModel } from '../../../shared/result.model';
import { QuarterlyTaxReceiptModel } from './quarterly-tax-receipt.model';
import { ApiResponse } from '../../../models/base';

const LIST_ENDPOINT = 'quarterly-tax-receipts';

@Injectable({
  providedIn: 'root',
})
export class QuarterlyTaxReceiptService {
  preinvoiceList: QuarterlyTaxReceiptModel[] = [];

  private readonly http = inject(HttpClient);
  private readonly saveRequestSubject = new BehaviorSubject<boolean>(false);
  public readonly saveRequestObservable$: Observable<boolean> =
    this.saveRequestSubject.asObservable();

  public saveRequestUpdateValue(value: boolean): void {
    this.saveRequestSubject.next(value);
  }

  async add(model: QuarterlyTaxReceiptModel): Promise<QuarterlyTaxReceiptModel> {
    const response = await firstValueFrom(
      this.http.post<ApiResponse<QuarterlyTaxReceiptModel>>(
        `${environment.apiUrl}/${LIST_ENDPOINT}`,
        model
      )
    );

    return response.data;
  }

  async update(model: QuarterlyTaxReceiptModel): Promise<QuarterlyTaxReceiptModel> {
    const response = await firstValueFrom(
      this.http.put<ApiResponse<QuarterlyTaxReceiptModel>>(
        `${environment.apiUrl}/${LIST_ENDPOINT}/${model.uid}`,
        model
      )
    );

    return response.data;
  }

  async delete(uid: string): Promise<string> {
    const response = await firstValueFrom(
      this.http.delete<{ Message: string }>(`${environment.apiUrl}/${LIST_ENDPOINT}/${uid}`)
    );

    return response.Message;
  }

  async get(uid: string): Promise<QuarterlyTaxReceiptModel> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<QuarterlyTaxReceiptModel>>(
        `${environment.apiUrl}/${LIST_ENDPOINT}/${uid}`
      )
    );

    return response.data;
  }

  async getList(
    offset?: number,
    limit?: number
  ): Promise<ResultModel<QuarterlyTaxReceiptModel>> {
    let params = new HttpParams();

    if (offset !== undefined) {
      params = params.set('offset', offset.toString());
    }

    if (limit !== undefined) {
      params = params.set('limit', limit.toString());
    }

    const response = await firstValueFrom(
      this.http.get<ApiResponse<ResultModel<QuarterlyTaxReceiptModel>>>(
        `${environment.apiUrl}/${LIST_ENDPOINT}`,
        { params }
      )
    );

    return response.data;
  }
}